import React from 'react';

import InscricaoProvider from './context/provider';
import EstruturaEtapas from './etapas/EstruturaEtapas';


function Inscricao() {
  return (
    <InscricaoProvider>
      <EstruturaEtapas />
    </InscricaoProvider>
  )
}

export default Inscricao
